import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from './axiosBaseQuery'
import { baseUrl } from './axiosInstance'

const enquiryApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'enquiryApi',
  tagTypes: ['enquiry'],
  endpoints: () => ({})
})

export default enquiryApi
